<template>
  <div>
    <!-- 头部 -->
    <Header ref="headerCpt" @updateUserInfo="userInfoChange"></Header>
    <!-- <banner ref="header" @gettoken="gettoken"></banner> -->
    <cebianlan></cebianlan>
    <!-- 课程详情 -->
    <div class="details">
      <div class="yuyuyu">
        <el-dialog
          :visible.sync="code"
          title=""
          width="320px"
          style="border-radius: 40px"
          center
        >
          <h3 style="text-align: center" class="kechengduihuan">课程兑换码</h3>
          <p class="huoqulist">（兑换码请到相关老师处获取）</p>
          <el-form
            label-width="120px"
            label-suffix="："
            style="margin-top: 30px; margin-bottom: 20px"
          >
            <div class="duihuan-content">
              <el-input v-model="codeData" placeholder="请输入兑换码" />
              <div slot="footer">
                <div class="lijiduan" type="primary" @click="useCdk()">
                  兑换
                </div>
              </div>
            </div>
            <div style="height: 20px">
              <p class="yiguoqilist">{{ this.errData }}</p>
            </div>
          </el-form>
        </el-dialog>
      </div>
      <div class="container">
        <!-- 详情头部 -->
        <div class="details-header">
          {{ course.cateNameChain }}-> {{ course.name }}
        </div>
        <!-- 视频部分 -->
        <div class="video">
          <div
            v-if="gaodulist >= 856"
            class="video-consultation"
            style="
              position: fixed;
              top: -20px;
              width: 1260px;
              z-index: 1000;
              box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.16);
            "
          >
            <!-- <p>{{ gaodulist }}</p> -->
            <!-- <div class="video-consultation-left">
              <p>{{ course.name }}</p>
              <p v-if="numStatus == 1">
                <img src="./images/left.png" alt="" />
                <span>报名人数：{{ studyNum }}</span>
              </p>
              
            </div>
           
            <div class="video-consualtation-right" @click="handleShowWxImg">
              <a>立即咨询</a>
            </div>
            <div v-if="comment" class="video-consultation-mid">
               <span class="video-consultation-mid-box"><span>我的评测：</span>{{comment}}</span>
            </div> -->
            <div
              v-if="discount_price == null && buy == 0"
              style="float: left"
              class="shijijia"
            >
              ¥{{ price }}
            </div>
            <div
              v-if="discount_price != null && buy == 0"
              style="float: left"
              class="shijijia"
            >
              ¥{{ discount_price }}
            </div>
            <div
              v-if="discount_price != null && buy == 0"
              style="float: left; margin-left: 22.5px; margin-top: 29px"
            >
              <span class="yuanjia">¥{{ price }}</span
              ><br />
              <img
                style="margin-top: 4px"
                src="./images/jinqiyouhui.png"
                alt=""
              />
            </div>
            <div
              v-if="numStatus == 1"
              style="
                float: left;
                margin-top: 49px;
                margin-left: 50px;
                display: flex;
              "
            >
              <img src="./images/bianzuj.png" alt="" />
              <p class="baomingrs">报名人数：{{ studyNum }}</p>
            </div>
            <div
              v-if="buy == 0"
              style="
                float: right;
                display: flex;
                margin-top: 25px;
                margin-right: 30px;
              "
            >
              <div class="zuozixun" @click="handleShowWxImg">咨询课程</div>
              <div class="yougoumai" @click="handleToCourseDetail">
                立即购买
              </div>
            </div>
            <div
              v-if="buy == 1"
              class="goumaigous"
              style="float: right; margin-top: 25px; margin-right: 30px"
              @click="handleShowWxImg"
            >
              立即咨询
            </div>
            <div class="contentWx-cover" v-if="isShowWxImg">
              <div class="contentWx-img" v-if="course.wechat_img">
                <div>微信扫一扫咨询</div>
                <img :src="course.wechat_img" alt="" />
                <div>扫码添加咨询顾问咨询课程，资料</div>
                <img
                  style="position: absolute; top: 0px; right: 20px; width: 20px"
                  @click="handleShowWxImg"
                  src="./images/guanbizixun.png"
                  alt=""
                />
              </div>
              <div class="contentWx-img" v-else>
                <div style="margin-bottom: 100px">暂无咨询方式</div>
                <!-- <button @click="handleShowWxImg">X</button> -->
                <img
                  style="
                    position: absolute;
                    top: 00px;
                    right: 20px;
                    width: 20px;
                  "
                  @click="handleShowWxImg"
                  src="./images/guanbizixun.png"
                  alt=""
                />
              </div>
            </div>
          </div>
          <div class="course-content-main">
            <div
              class="course-img"
              :style="{ backgroundImage: 'url(' + course.cover + ')' }"
              v-if="!playStatus"
            ></div>
            <div class="course-img" v-show="playStatus">
              <template v-if="isThreeScreenCourse">
                <div style="height: 100%; background: #000000">
                  <SHPlayer
                    videoType="vod"
                    class="main-video"
                    ref="whiteBoard"
                    :showControls="false"
                    :runObj="{}"
                    :copyrightObj="{}"
                    @loadstart="onLoadstart"
                    @play="onPlayerPlay"
                    @pause="onPlayerPause"
                    @ended="onPlayerEnded"
                  />
                </div>
              </template>
              <template v-else>
                <SHPlayer
                  videoType="vod"
                  ref="mainVideo"
                  :runObj="{}"
                  :copyrightObj="{}"
                  @timeupdate="handleListenCurTimeChange"
                  @play="onPlayerPlay"
                  @pause="onPlayerPause"
                  @ended="onPlayerEnded"
                  @loadstart="onLoadstart"
                  class="main-video"
                />
              </template>
            </div>
            <div class="course-chapter" ref="course_chapter">
              <template v-if="isThreeScreenCourse">
                <div style="height: 200px">
                  <SHPlayer
                    videoType="vod"
                    ref="cameraVideo"
                    :showRate="false"
                    class="camera-video"
                    @loadstart="onLoadstart"
                    :playType="playType"
                    @play="handlePlay"
                    @pause="handlePause"
                    @seeking="handleSeek"
                  />
                </div>
              </template>
              <template v-if="hasSection">
                <div
                  v-for="(section, index) in sectionList"
                  :key="section.sectionId"
                  :ref="'part' + section.sectionId"
                  class="chapter-main"
                >
                  <div
                    class="chapter-title"
                    @click="handleStretchPart(section.sectionId, index)"
                  >
                    <span class="chapter-text" :title="section.sectionName">{{
                      section.sectionName
                    }}</span>
                    <i
                      class="iconfont title-icon"
                      :ref="'icon' + section.sectionId"
                      >&#xe665;</i
                    >
                  </div>
                  <div
                    class="course-chapter-item"
                    v-for="(chapter, idx) in section.chapters"
                    :key="chapter.id"
                    :ref="'chapterJie' + chapter.id"
                  >
                    <div class="chapter-item-num">{{ idx + 1 }}</div>
                    <div class="chapter-item-content">
                      <div class="item-content-top">
                        <div class="chapter-review" v-if="chapter.type == 3">
                          回放
                        </div>
                        <div class="chapter-review" v-if="chapter.type == 2">
                          录播
                        </div>
                        <div
                          class="chapter-review"
                          style="background: #10a675"
                          v-if="chapter.type == 1 || chapter.type == 4"
                        >
                          直播
                        </div>
                        <div
                          class="chapter-item-title"
                          :id="'scroll-' + section.sectionId + '-' + idx"
                        >
                          {{ chapter.name }}
                        </div>
                        <div class="keduihuan" v-if="chapter.show == 1">
                          可兑换
                        </div>
                      </div>
                      <div class="item-content-bottom">
                        {{ chapter.start_time }}
                      </div>
                      <!-- lubo -->
                      <div
                        v-if="chapter.videos.length > 3 && chapter.type == 3"
                        class="sort"
                      >
                        <div
                          :class="sortimgs[chapter.id] ? 'stbx stbx1' : 'stbx'"
                          @click="sorta(chapter.id)"
                        >
                          {{
                            sortform[chapter.id] == 1
                              ? '升序'
                              : sortform[chapter.id] == 0
                              ? '降序'
                              : '排序'
                          }}
                          <img
                            class="sortimg"
                            v-if="!sortimgs[chapter.id]"
                            src="@/views/images/sort.png"
                            alt=""
                          /><img
                            v-else
                            class="sortimg"
                            :src="sortimgs[chapter.id]"
                            alt=""
                          />
                        </div>
                      </div>
                      <template v-if="chapter.videos.length">
                        <div
                          class="chapter-review-item"
                          v-for="video in chapter.videos"
                          :key="video.id"
                          @click="liveAutha(section, chapter, video)"
                          :class="
                            video.id == reviewActiveId ? 'review-active' : ''
                          "
                        >
                          <i class="iconfont">&#xe7e9;</i>
                          <span
                            class="review-item-name"
                            style="margin-right: 5px; word-break: break-word"
                            >{{ video.name }}</span
                          >
                          <!-- <span style="flex:1"></span> -->
                          <div>
                            <span class="review-item-time">{{
                              formateSeconds(video.duration)
                            }}</span>
                            <span class="aglook" v-if="video.is">上次看到</span>
                          </div>
                        </div>
                      </template>
                    </div>
                    <div
                      v-if="chapter.status === 2 || chapter.status === 4"
                      @click="liveAuth(chapter, chapter.show)"
                      class="live"
                    >
                      <i
                        class="iconfont live-status"
                        v-if="chapter.status === 2"
                        >&#xe6e1;</i
                      >
                      <div class="enter-live">进入直播</div>
                    </div>
                    <div class="live-over">
                      <div v-if="chapter.status === 3">直播已结束</div>
                      <div
                        class="download_fj"
                        v-if="chapter.file && istoken"
                        @click="
                          dwxaizaifj(chapter, JSON.parse(chapter.file)[0].url)
                        "
                        :download="JSON.parse(chapter.file)[0].title"
                        target="_blank"
                      >
                        下载附件
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <!-- 无章节 -->
              <template v-else>
                <div
                  class="course-chapter-item"
                  v-for="(chapter, idx) in chapterList"
                  :key="chapter.id"
                >
                  <div class="chapter-item-num">{{ idx + 1 }}</div>
                  <div class="chapter-item-content">
                    <div class="item-content-top">
                      <!-- <div class="chapter-review" v-if="innerItem.videos.length">回放</div> -->
                      <div class="chapter-review" v-if="chapter.type == 3">
                        回放
                      </div>
                      <div class="chapter-review" v-if="chapter.type == 2">
                        录播
                      </div>
                      <div
                        class="chapter-review"
                        style="background: #10a675"
                        v-if="chapter.type == 1 || chapter.type == 4"
                      >
                        直播
                      </div>
                      <div class="chapter-item-title" :title="chapter.name">
                        {{ chapter.name }}
                      </div>
                      <div class="titleshow">{{ chapter.name }}</div>
                      <div class="keduihuan" v-if="chapter.show == 1">
                        可兑换
                      </div>
                    </div>
                    <div class="item-content-bottom">
                      {{ chapter.start_time }}
                    </div>

                    <template v-if="chapter.videos.length">
                      <div
                        class="chapter-review-item"
                        v-for="video in chapter.videos"
                        :key="video.id"
                        @click="liveAutha({}, chapter, video)"
                        :class="
                          video.id == reviewActiveId ? 'review-active' : ''
                        "
                      >
                        <i class="iconfont">&#xe7e9;</i>
                        <span
                          class="review-item-name"
                          style="margin-right: 5px"
                          >{{ video.name }}</span
                        >
                        <span class="review-item-time">{{
                          formateSeconds(video.duration)
                        }}</span>
                      </div>
                    </template>
                  </div>
                  <div
                    v-if="chapter.status === 2 || chapter.status === 4"
                    @click="liveAuth(chapter, chapter.show)"
                    class="live"
                  >
                    <i class="iconfont live-status" v-if="chapter.status === 2"
                      >&#xe6e1;</i
                    >
                    <div class="enter-live">进入直播</div>
                  </div>
                  <div class="live-over">
                    <div v-if="chapter.status === 3">直播已结束</div>
                    <a
                      :href="JSON.parse(chapter.file)[0].url"
                      :download="JSON.parse(chapter.file)[0].title"
                      target="_blank"
                      v-if="chapter.file && istoken"
                      >下载附件</a
                    >
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="video-consultation">
            <!-- <p>{{ gaodulist }}</p> -->
            <!-- <div class="video-consultation-left">
              <p>{{ course.name }}</p>
              <p v-if="numStatus == 1">
                <img src="./images/left.png" alt="" />
                <span>报名人数：{{ studyNum }}</span>
              </p>
              
            </div>
           
            <div class="video-consualtation-right" @click="handleShowWxImg">
              <a>立即咨询</a>
            </div>
            <div v-if="comment" class="video-consultation-mid">
               <span class="video-consultation-mid-box"><span>我的评测：</span>{{comment}}</span>
            </div> -->
            <div
              v-if="discount_price == null && buy == 0"
              style="float: left"
              class="shijijia"
            >
              ¥{{ price }}
            </div>
            <div
              v-if="discount_price != null && buy == 0"
              style="float: left"
              class="shijijia"
            >
              ¥{{ discount_price }}
            </div>
            <div
              v-if="discount_price != null && buy == 0"
              style="float: left; margin-left: 22.5px; margin-top: 29px"
            >
              <span class="yuanjia">¥{{ price }}</span
              ><br />
              <img
                style="margin-top: 4px"
                src="./images/jinqiyouhui.png"
                alt=""
              />
            </div>
            <div
              v-if="numStatus == 1"
              style="
                float: left;
                margin-top: 49px;
                margin-left: 50px;
                display: flex;
              "
            >
              <img src="./images/bianzuj.png" alt="" />
              <p class="baomingrs">报名人数：{{ studyNum }}</p>
            </div>
            <div
              v-if="buy == 0"
              style="
                float: right;
                display: flex;
                margin-top: 25px;
                margin-right: 30px;
              "
            >
              <div class="zuozixun" @click="handleShowWxImg">咨询课程</div>
              <div class="yougoumai" @click="handleToCourseDetail">
                立即购买
              </div>
            </div>
            <div
              v-if="buy == 1"
              class="goumaigous"
              style="float: right; margin-top: 25px; margin-right: 30px"
              @click="handleShowWxImg"
            >
              立即咨询
            </div>
            <div class="contentWx-cover" v-if="isShowWxImg">
              <div class="contentWx-img" v-if="course.wechat_img">
                <div>微信扫一扫咨询</div>
                <img :src="course.wechat_img" alt="" />
                <div>扫码添加咨询顾问咨询课程，资料</div>
                <img
                  style="position: absolute; top: 0px; right: 20px; width: 20px"
                  @click="handleShowWxImg"
                  src="./images/guanbizixun.png"
                  alt=""
                />
              </div>
              <div class="contentWx-img" v-else>
                <div style="margin-bottom: 100px">暂无咨询方式</div>
                <img
                  style="position: absolute; top: 0px; right: 20px; width: 20px"
                  @click="handleShowWxImg"
                  src="./images/guanbizixun.png"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
        <!-- 课程信息 -->
        <div class="information">
          <div class="information-left">
            <div class="information-container">
              <!-- 课程信息头部 -->
              <div class="information-left-header">
                <div class="information-left-header-left">课程介绍</div>
                <div class="change-class">
                  <div class="class-title">班级:</div>
                  <el-select @change="classChange" v-model="class_id">
                    <el-option
                      v-for="item in options"
                      :key="item.period"
                      :label="item.period"
                      :value="item.id"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div v-html="course.desc" class="info-content"></div>

              <!-- 课程目录 -->
              <!-- <div class="information-left-catalogue">
                <div class="mulu" v-for="(item, index) in chapterList" :key="item.id">
                  <span class="span01">{{ index > 8 ? index + 1 : '0' + (index + 1) }}</span>
                  <div>
                    <p>
                      <span class="leixin" v-if="item.type === 2">回放</span>
                      <span class="leixin" v-else-if="item.type === 1">直播</span>
                      {{ item.name }}
                    </p>
                    <p>{{ item.start_time }}</p>
                  </div>
                  <a @click="liveAuth(item.id)" style="cursor:pointer;">进入直播</a>
                  <div style="width: 700px;height: 60px;margin-left: 66px;margin-top: 10px;" v-for="(item1, index) in item.videos" :key="item1.id">
                    <div>
                      <span class="linyi">{{ index > 8 ? index + 1 : '0' + (index + 1) }}</span>
                      <span class="chushia">{{ item1.name }}</span>
                    </div>
                    <div style="float: right;">
                      <p @click="liveAutha(item1.id)" style="font-size: 14px;color: #10a675;cursor:pointer;margin: auto 0;">看回放</p>
                    </div>
                  </div>
                </div>
              </div> -->
            </div>
          </div>
          <!-- <div class="information-right">
              <div style="width: 300px; margin: 0 auto;">
                <div class="information-right01">
                  <span>LOGO</span>
                  <div>
                    <p>腾慧科技网校</p>
                    <p>业界优秀在线课堂教育机构</p>
                  </div>
                </div>
                <div class="information-right02">
                  <div>
                    <p>学习人数</p>
                    <span>89.8w</span>
                  </div>
                  <div>
                    <p>学习人数</p>
                    <span>89.8w</span>
                  </div>
                  <div>
                    <p>学习人数</p>
                    <span>89.8w</span>
                  </div>
                </div>
                <div class="information-right03">
                  <p>{{desc}}</p>
                </div>
              </div>
            </div> -->
        </div>
      </div>
      <div style="width: 100%; height: 20px"></div>
      <div style="clear: both"></div>
    </div>
    <Login ref="loginH" @updateLoginState="changeLoginState" />
    <!-- 尾部 -->
    <!-- <bottom></bottom> -->
    <Footer></Footer>
  </div>
</template>

<script>
import Header from './mofang/header.vue';
import cebianlan from './cebianlan';
import { mapGetters } from 'vuex';
import Login from './login';
import SHPlayer from 'shplayer';
import axios from 'axios';
import Footer from './mofang/footer.vue';
import { getPrefixHost } from '@/utils/index';
import { useOrgConfig } from '@/utils/useUserConfig.js';

export default {
  components: {
    SHPlayer,
    Login,
    Header,
    Footer,
    cebianlan,
  },
  data() {
    return {
      memory: {},
      sortimgs: {},
      sortform: {},
      domain: 'www.tengface.com',
      coursesa: [],
      desc: '',
      options: [],
      value: '',
      chapterList: [],
      sectionList: [],
      class_id: '',
      studyNum: '',
      course: {},
      isShowWxImg: false,
      VODData: null,
      reviewActiveId: '',
      hasSection: true,
      initHeight: 56,
      numStatus: '',
      heartBeat: null,
      playStatus: '',
      vodDom: null,
      uid: '',
      fileId: '',
      wx_h5_url: 'https://u.shanhuclass.cn',
      currentSectionId: '',
      currentVideoId: '',
      sectionVideoList: [],
      chartTimeDataa: {
        rows: [],
      },
      comment: '',
      isFirst: true,
      innerItem: {},
      cameraVideoUrl: '',
      whiteBoardVideoUrl: '',
      remainingTime: 0,
      code: false,
      codeData: '',
      codeArr: [],
      errData: '',
      istoken: '',
      gaodulist: 0,
      price: '',
      discount_price: '',
      kechengid: '',
      buy: '',
      licenseUrl:
        'https://license.vod2.myqcloud.com/license/v2/1317978474_1/v_cube.license',
      cameraVideoPlayer: null,
      whiteBoardPlayer: null,
      tfPlayer: null,
      isThreeScreenCourse: false,
      playParams: {},
      whiteBoardPlayParams: {},
      cameraVideoPlayParams: {},
      memoryPoints: 0,
      playType: '',
      chapter_id: '',
    };
  },
  created() {
    this.istoken = localStorage.getItem('token');
  },
  beforeDestroy() {
    const body = document.querySelector('body');
    body.removeAttribute('style');
    window.removeEventListener(
      'beforeunload',
      (e) => this.historycallback(),
      false
    );
    this.historycallback();
    clearInterval(this.heartBeat);
  },
  mounted() {
    window.addEventListener('scroll', this.scrollToTop);
    this.$store.dispatch('getOrgID', this.$store.state.domain).then(async () => {
      this.uid = this.$store.state.user.org_id;
      this.getCourseInfo();
      this.listClass();
      // this.getMiniConfigAll();
      const { live_domain } = await useOrgConfig()
      this.wx_h5_url = live_domain
      this.infolist();
    });

    if (this.$route.query.sectionId) {
      this.playHistoryVideo();
    }
    window.addEventListener(
      'beforeunload',
      (e) => this.historycallback(),
      true
    );
  },
  computed: {
    // 获取商户id
    ...mapGetters({
      org_id: 'user/getOrgId',
      fans_id: 'user/getFansId',
    }),
    // 将秒转化为时分秒
    formateSeconds() {
      return function (endTime) {
        let secondTime = parseInt(endTime); // 将传入的秒的值转化为Number
        let min = 0; // 初始化分
        let h = 0; // 初始化小时
        let result = '';
        if (secondTime > 60) {
          // 如果秒数大于60，将秒数转换成整数
          min = parseInt(secondTime / 60); // 获取分钟，除以60取整数，得到整数分钟
          secondTime = parseInt(secondTime % 60); // 获取秒数，秒数取佘，得到整数秒数
          if (min > 60) {
            // 如果分钟大于60，将分钟转换成小时
            h = parseInt(min / 60); // 获取小时，获取分钟除以60，得到整数小时
            min = parseInt(min % 60); // 获取小时后取佘的分，获取分钟除以60取佘的分
          }
        }
        result = `${h.toString().padStart(2, '0')}:${min
          .toString()
          .padStart(2, '0')}:${secondTime.toString().padStart(2, '0')}`;
        return result;
      };
    },
  },
  methods: {
    dwxaizaifj(chapter, item1) {
      if (chapter.status == 2 || chapter.status == 4 || chapter.status == 3) {
        const { status, id } = chapter;
        const data = {
          course_id: this.$route.params.setid,
          class_id: this.class_id,
          chapter_id: id,
        };

        // if (status !== 2 && status !== 4) return
        this.$axios.post('/stu/course/liveAuth', data).then((res) => {
          if (res.data.code === 200) {
            window.open(item1);
          } else if (res.data.code === 400) {
            this.$message({
              type: 'info',
              message: res.data.message,
            });
          } else {
            this.$message({
              type: 'info',
              message: '请登录后再试',
            });
          }
        });
      } else {
        const data = {
          course_id: chapter.course_id
            ? chapter.course_id
            : this.$route.params.setid,
          class_id: chapter.class_id ? chapter.class_id : this.class_id,
          chapter_id: chapter.id,
        };
        this.$axios
          .post('https://onlinehy.shkt.online' + '/chapter/chapterAuth', data)
          .then((res) => {
            if (res.data.code === 200) {
              console.log(res.data.data.is_auth);
              if (res.data.data.is_auth == true) {
                window.open(item1);
              } else {
                this.$message({
                  type: 'info',
                  message: '权限已过期，请联系老师开通',
                });
              }
            } else if (res.data.code === 400) {
              this.$message({
                type: 'info',
                message: res.data.message,
              });
            }
          });
      }
    },
    playHistoryVideo() {
      let shipingID = localStorage.getItem('shipingID');
      let localViewTime = localStorage.getItem('currentTime' + shipingID);
      const { sectionId, video_id, view_time, name, chapter_id } =
        this.$route.query;
      const { class_id, setid: course_id } = this.$route.params;
      const section = {
        sectionId,
      };
      const chapter = {
        class_id,
        course_id,
      };
      const video = {
        id: video_id,
        name,
        view_time: view_time ? view_time : localViewTime,
        chapter_id,
      };
      this.liveAutha(section, chapter, video);
    },
    historycallback() {
      if (!this.playStatus) return;
      let curTime = '';
      if (this.isThreeScreenCourse) {
        curTime = this.$refs.cameraVideo.getCurrentTime();
      } else {
        curTime = this.$refs.mainVideo.getCurrentTime();
      }
      this.curChooseVideo.view_time = curTime;
      if (Object.entries(this.curChooseVideo).length > 7 &&  curTime > 0) {
        this.$axios.post('/user/video/callback', this.curChooseVideo);
      }
    },
    // 跳转支付详情
    handleToCourseDetail() {
      this.$router.push({
        path: `/Paymentdetails/${this.kechengid}/${this.$route.params.setid}`,
      });
    },
    infolist() {
      const data = {
        id: this.$route.params.goodsId,
        ds_id: this.org_id,
      };
      if (localStorage.getItem('tengface_fans_id')) {
        data.fans_id = localStorage.getItem('tengface_fans_id');
      }
      this.$liveApi.post('/liveapi/api/goods/info', data).then((res) => {
        if (res.data.code == 200) {
          console.log(res.data);
          this.price = res.data.data.price;
          this.discount_price = res.data.data.discount_price;
          this.kechengid = res.data.data.id;
          this.buy = res.data.data.buy;
        }
      });
    },
    scrollToTop() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      this.gaodulist = scrollTop;
      console.log(scrollTop);
    },
    gettoken(token) {
      console.log(token, 'token来了');
      this.istoken = token;
    },
    userInfoChange() {
      this.istoken = localStorage.getItem('token');
    },
    historycallbacks() {
      if (!this.playStatus) return;
      let curTime = '';
      if (this.isThreeScreenCourse) {
        curTime = this.$refs.cameraVideo.getCurrentTime();
      } else {
        curTime = this.$refs.mainVideo.getCurrentTime();
      }
      this.curChooseVideo.view_time = curTime;
      var data = new FormData();
      data.push(this.curChooseVideo);
      Navigator.sendBeacon(
        'https://online.tenghuiwangxiao.cn/user/video/callback',
        data
      );
    },
    async sorta(ind) {
      // console.log(ind);
      let char_sort = '';
      if (!this.sortform[ind]) {
        this.sortform[ind] = 0;
      }
      this.sortform[ind]++;
      if (this.sortform[ind] == 1) {
        this.sortimgs[ind] = require('@/views/images/sorts.png');
        char_sort = 'asc';
      } else if (this.sortform[ind] == 2) {
        this.sortimgs[ind] = require('@/views/images/sortx.png');
        this.sortform[ind] = 0;
        char_sort = 'desc';
      }
      console.log(this.sortform, 'ind');
      await this.getClassCode();
      this.listSections(char_sort);
    },
    onPlayerEnded() {
      if (this.sectionVideoList.length > 0) {
        let sectionListVideo = this.sectionVideoList.find((item) => {
          return item.sectionId == this.currentSectionId;
        });
        if (sectionListVideo) {
          let vidoes = sectionListVideo.video;
          let index = vidoes.findIndex((item) => {
            return item.id == this.currentVideoId;
          });

          if (index > -1 && index < vidoes.length - 1) {
            let voideItem = vidoes[index + 1];
            this.liveAutha(sectionListVideo, { show: 2 }, voideItem);
          }
        }
      }
    },
    onPlayerPlay() {
      this.playStatus = 2;
    },
    onPlayerPause() {
      this.playStatus = 3;
    },
    onLoadstart() {
      // 存在参数，跳转播放记忆点
      this.playStatus = 2;
      if (this.$route.query.sectionId) {
        if (this.isThreeScreenCourse) {
          this.$refs.cameraVideo.setCurrentTime(this.memoryPoints);
          this.$refs.whiteBoard.setCurrentTime(this.memoryPoints);
        } else {
          this.$refs.mainVideo.setCurrentTime(this.memoryPoints);
        }
      }
    },
    classChange() {
      // this.listChapters()
      this.classInfo();
      this.getClassCode();
      this.listSections();
      this.historycallback(this.vodDom.currentTime);
    },

    // 课程详情接口
    getCourseInfo() {
      const data = {
        org_id: this.org_id,
        course_id: this.$route.params.setid,
      };
      this.$axios.post('/stu/course/getCourseInfo', data).then((res) => {
        if (res.data.code === 200) {
          res.data.data.desc = res.data.data.desc.replace(
            /<img /g,
            '<img style= "width:100%"'
          );
          this.course = res.data.data;
        }
      });
    },

    // 课程班级列表接口
    async listClass() {
      const data = {
        org_id: this.org_id,
        course_id: this.$route.params.setid,
      };
      const res = await this.$axios.post('/stu/course/listClass', data);
      if (res.data.code === 200) {
        this.options = res.data.data;
        let hasAccessArr = res.data.data.filter((item) => item.access !== 0);
        if (res.data.data && res.data.data.length > 0) {
          if (hasAccessArr.length === 0) {
            // 没有权限的话，优先展示最新的班级
            this.class_id = res.data.data[0].id // res.data.data[res.data.data.length - 1].id;
          } else {
            this.class_id = hasAccessArr[0].id;
          }
          if (this.$route.params.class_id) {
            this.class_id = parseInt(this.$route.params.class_id);
          }
          // this.listChapters()
          this.classInfo();
          await this.getClassCode();
          this.listSections();
        }
      }
    },

    // 章节列表接口
    // listChapters() {
    //   const data = {
    //     org_id: this.org_id,
    //     course_id: this.$route.query.setid,
    //     class_id: this.class_id,
    //     page: 1,
    //     num: 20
    //   }
    //   this.$axios.post('/stu/course/listChapters', data).then(res => {
    //     this.chapterList = res.data.data.list
    //     this.classInfo()
    //   })
    // },
    listSections(char_sort) {
      const data = {
        org_id: this.org_id,
        course_id: this.$route.params.setid,
        class_id: this.class_id,
        page: 1,
        num: 10,
        char_sort,
      };
      this.$axios.post('/stu/course/listSections', data).then((res) => {
        if (res.data.code == 200) {
          if (res.data.data[0].sectionId) {
            this.sectionList = res.data.data;
            this.hasSection = true;
            this.$nextTick(() => {
              if (this.isFirst) {
                let chapterindex = 0;
                let chapterJie = null;
                //let show = 1
                // 直播优先, 上次观看再后
                try {
                  this.sectionList.forEach((item, index) => {
                    item.chapters.forEach((item2) => {
                      if (this.codeArr.indexOf(item2.id) != -1) {
                        item2.show = 1;
                      } else {
                        item2.show = 2;
                      }
                      if (item2.status == 2) {
                        // 直播
                        chapterindex = index;
                        chapterJie = item2.id;
                        throw new Error(chapterindex);
                      } else {
                        // 回放
                        item2.videos.forEach((videoList) => {
                          if (videoList.is) {
                            chapterindex = index;
                            chapterJie = item2.id;
                          }
                        });
                      }
                    });
                  });
                } catch (e) {
                  // if (e.message != "End") throw e;
                }
                if (!char_sort) {
                  // console.log(this.chapterList[0],'this.chapterList[0]');
                  if (this.$route.query.sectionId) {
                    this.$nextTick(() => {
                      this.handleStretchPart(this.$route.query.sectionId);
                    });
                    let scrollTop = document.querySelector('.course-chapter');
                    scrollTop.scrollTop =
                      this.$refs[
                        'part' + this.$route.query.sectionId
                      ][0].offsetTop;
                    // console.log(,'document.querySelector');
                    console.log(
                      this.$refs['part' + this.$route.query.sectionId][0]
                        .offsetTop,
                      'document.sectionId'
                    );
                  } else {
                    this.$nextTick(() => {
                      this.handleStretchPart(
                        this.sectionList[chapterindex].sectionId
                      );
                    });
                  }
                }

                if (this.isFirst && chapterJie) {
                  this.$nextTick(() => {
                    const parent = this.$refs.course_chapter;
                    const position =
                      this.$refs['chapterJie' + chapterJie][0].offsetTop -
                      430 +
                      200;
                    if (position < 0) return;
                    console.log(parent, 'parent');
                    console.log(position, 'position');
                    setTimeout(() => {
                      parent.scrollTo({
                        top: position,
                        behavior: 'smooth',
                      });
                    }, 1000);
                  });
                }
                this.isFirst = false;
              } else {
                if (!char_sort) {
                  this.$nextTick(() => {
                    this.handleStretchPart(this.sectionList[0].sectionId);
                  });
                }
              }
            });
          } else {
            this.chapterList = res.data.data[0].chapters;
            this.hasSection = false;
          }
          const list = [];
          this.sectionList.forEach((item) => {
            let vodes = [];
            item.chapters.forEach((item1) => {
              if (this.codeArr.indexOf(item1.id) != -1) {
                item1.show = 1;
              } else {
                item1.show = 2;
              }
              if (item1.videos.length !== 0) {
                vodes = vodes.concat(item1.videos);
              }
            });
            list.push({
              sectionId: item.sectionId,
              video: vodes,
            });
            //  console.log(item.chapters)
          });
          this.sectionVideoList = list;
        }
      });
    },

    // 直播鉴权
    liveAuth(item, show) {
      console.log(item);
      const { status, id } = item;
      const data = {
        course_id: this.$route.params.setid,
        class_id: this.class_id,
        chapter_id: id,
      };

      if (status !== 2 && status !== 4) return;
      this.$axios.post('/stu/course/liveAuth', data).then((res) => {
        if (res.data.code === 200) {
          if (item.type == 4) {
            this.fakeLiveJump(item, res.data);
          } else {
            this.liveAddress(item, res.data);
          }
        } else if (res.data.code === 400) {
          if (show == 1) {
            this.chapter_id = item.id;
            this.errData = '';
            this.code = true;
          } else {
            this.$message({
              type: 'info',
              message: res.data.message,
            });
          }
        } else {
          this.$message({
            type: 'info',
            message: '请登录后再试',
          });
          this.$refs.loginH.open();
        }
      });
    },

    // 录播鉴权
    liveAutha(section, chapter, video) {
      this.curChooseVideo = {
        chapter_id: video.chapter_id,
        course_id: chapter.course_id,
        class_id: chapter.class_id,
        video_id: video.id,
        file_id: video.file_id,
        name: video.name,
        duration: video.duration,
        sectionId: section.sectionId,
      };
      this.currentSectionId = section.sectionId;
      this.currentVideoId = video.id;
      const data = {
        course_id: chapter.course_id
          ? chapter.course_id
          : this.$route.params.setid,
        class_id: chapter.class_id ? chapter.class_id : this.class_id,
        chapter_id: video.chapter_id,
        video_id: video.id,
      };
      this.$axios.post('/stu/course/videoAuth', data).then((res) => {
        if (res.data.code === 200) {
          localStorage.setItem('shipingID', video.id);
          this.reviewActiveId = video.id;
          this.memoryPoints = video.view_time;
          this.handlePlayVideo(res.data.data.video, video.view_time);
        } else if (res.data.code === 400) {
          if (chapter.show == 1) {
            this.chapter_id = video.chapter_id;
            this.errData = '';
            this.code = true;
          } else {
            this.$message({
              type: 'info',
              message: res.data.message,
            });
          }
        } else {
          this.$message({
            type: 'info',
            message: '请登录后再试',
          });
          this.$refs.loginH.open();
        }
      });
    },
    // 定位播放时间
    handleListenCurTimeChange(val) {
      let shipingID = localStorage.getItem('shipingID');
      const currentTime = val;
      localStorage.setItem('currentTime' + shipingID, currentTime);
    },
    // 处理视频播放
    handlePlayVideo(item) {
      const {
        mp4Url,
        sMp4Url,
        file_id,
        appid,
        sign,
        s_appid,
        s_file_id,
        s_sign,
        original,
        cfileid,
        s_cfileid
      } = item;
      this.fileId = file_id;
      let options = {
        fileID: cfileid || file_id,
        appID: appid,
        psign: sign,
        url: mp4Url,
        playType: 'file_id',
        licenseUrl: this.licenseUrl,
      };
      if (original === 1) {
        if (mp4Url && sMp4Url) {
          // 三分屏课程 url播放
          const sOptions = {
            sources: [sMp4Url],
            playType: 'url',
            licenseUrl: this.licenseUrl,
          };
          options = {
            sources: [mp4Url],
            playType: 'url',
            licenseUrl: this.licenseUrl,
          };
          this.isThreeScreenCourse = true;
          this.$nextTick(() => {
            this.$refs.cameraVideo.setPlayerParams({
              ...options,
              ...this.cameraVideoInitOptions,
            });
            this.$refs.cameraVideo.play();
            this.$refs.whiteBoard.setPlayerParams({
              ...sOptions,
              ...this.whiteBoardInitOptions,
            });
            this.$refs.whiteBoard.play();
          });
          return;
        }
        if (mp4Url && !sMp4Url) {
          // 普通课程 url播放
          options = {
            sources: [mp4Url],
            playType: 'url',
            licenseUrl: this.licenseUrl,
          };
          this.isThreeScreenCourse = false;
          this.$nextTick(() => {
            this.$refs.mainVideo.setPlayerParams(options);
            this.$refs.mainVideo.play();
          });
          return;
        }
        if (file_id && s_file_id) {
          // 三分屏课程 file_id播放
          this.playType = 'file_id';
          this.isThreeScreenCourse = true;
          const sOptions = {
            fileID: s_cfileid || s_file_id,
            appID: s_appid,
            psign: s_sign,
            licenseUrl: this.licenseUrl,
            playType: 'file_id',
          };
          this.$nextTick(() => {
            this.$refs.cameraVideo.setPlayerParams({
              ...options,
              ...this.cameraVideoInitOptions,
            });
            this.$refs.cameraVideo.play();
            this.$refs.whiteBoard.setPlayerParams({
              ...sOptions,
              ...this.whiteBoardInitOptions,
            });
            this.$refs.whiteBoard.play();
            // this.cameraVideoPlayParams = options
            // this.whiteBoardPlayParams = sOptions
          });
          return;
        }
        if (file_id && !s_file_id) {
          // 普通课程 file_id播放
          this.playType = 'file_id';
          this.isThreeScreenCourse = false;
          this.$nextTick(() => {
            this.$refs.mainVideo.setPlayerParams(options);
            this.$refs.mainVideo.play();
            // this.playParams = options
          });
          return;
        }
      } else {
        if (file_id && s_file_id) {
          // 三分屏课程 file_id播放
          this.playType = 'file_id';
          this.isThreeScreenCourse = true;
          const sOptions = {
            fileID: s_cfileid || s_file_id,
            appID: s_appid,
            psign: s_sign,
            licenseUrl: this.licenseUrl,
            playType: 'file_id',
          };
          this.$nextTick(() => {
            this.$refs.cameraVideo.setPlayerParams({
              ...options,
              ...this.cameraVideoInitOptions,
            });
            this.$refs.cameraVideo.play();
            this.$refs.whiteBoard.setPlayerParams({
              ...sOptions,
              ...this.whiteBoardInitOptions,
            });
            this.$refs.whiteBoard.play();
            // this.cameraVideoPlayParams = options
            // this.whiteBoardPlayParams = sOptions
          });
          return;
        }
        if (file_id && !s_file_id) {
          // 普通课程 file_id播放
          this.playType = 'file_id';
          this.isThreeScreenCourse = false;
          this.$nextTick(() => {
            this.$refs.mainVideo.setPlayerParams(options);
            this.$refs.mainVideo.play();
            // this.playParams = options
          });
          return;
        }
        if (mp4Url && sMp4Url) {
          // 三分屏课程 url播放
          const sOptions = {
            sources: [sMp4Url],
            playType: 'url',
            licenseUrl: this.licenseUrl,
          };
          options = {
            sources: [mp4Url],
            playType: 'url',
            licenseUrl: this.licenseUrl,
          };
          this.isThreeScreenCourse = true;
          this.$nextTick(() => {
            this.$refs.cameraVideo.setPlayerParams({
              ...options,
              ...this.cameraVideoInitOptions,
            });
            this.$refs.cameraVideo.play();
            this.$refs.whiteBoard.setPlayerParams({
              ...sOptions,
              ...this.whiteBoardInitOptions,
            });
            this.$refs.whiteBoard.play();
          });
          return;
        }
        if (mp4Url && !sMp4Url) {
          // 普通课程 url播放
          options = {
            sources: [mp4Url],
            playType: 'url',
            licenseUrl: this.licenseUrl,
          };
          this.isThreeScreenCourse = false;
          this.$nextTick(() => {
            this.$refs.mainVideo.setPlayerParams(options);
            this.$refs.mainVideo.play();
          });
          return;
        }
      }
      // 心跳上报
      this.$nextTick(() => {
        this.startVodTime(file_id);
      });
    },
    fakeLiveJump(item1, item) {
      // const liveUrl = `${this.wx_h5_url}/f?ds_id=${item1.ds_id}&tid=${
      //   item1.room_id
      // }&token=${
      //   item.data.liveToken
      // }&other=1&shool_token=${localStorage.getItem('token')}`
      console.log('qq', this.wx_h5_url);
      const liveUrl = `${this.wx_h5_url}/f?ds_id=${item1.ds_id}&tid=${
        item1.room_id
      }&token=${item.data.liveToken}&other=1&shool_token=${localStorage.getItem(
        'token'
      )}`;

      console.log('fakeLiveJump', liveUrl);

      location.href = liveUrl;
    },
    // 查询直播地址
    liveAddress(item1, item) {
      if (item1.play_style == 4) {
        location.href = `${this.wx_h5_url}/tcicMiddlePage/#/pc?classid=${item1.interact_id}&fans_id=${this.fans_id}&ds_id=${item1.ds_id}`;
      } else {
        const liveUrl = `${this.wx_h5_url}?ds_id=${item1.ds_id}&token=${
          item.data.liveToken
        }&other=1&shool_token=${localStorage.getItem('token')}`;
        console.log('liveAddress', liveUrl);
        location.href = liveUrl;
      }
    },
    getMiniConfig() {
      this.$axios
        .get(
          'https://tengface-live.oss-cn-beijing.aliyuncs.com/web/config/userConfig/' +
            this.org_id +
            '.json?a=' +
            new Date().valueOf()
        )
        .then((response) => {
          if (response.data) {
            if (response.data.wx_h5_url) {
              this.wx_h5_url = response.data.wx_h5_url;
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getMiniConfigAll() {
 
      this.$axios
        .get(
          'https://resshktonline.tengfacexuexi.com/web/config/miniConfig.json?a=' +
            new Date().valueOf()
        )
        .then((response) => {
          if (response.data) {
            if (response.data.wx_h5_url) {
              this.wx_h5_url = response.data.wx_h5_url;
            }
            if (response.data.wx_h5_main_host) {
              this.wx_h5_url = `https://${getPrefixHost(this.org_id)}.${response.data.wx_h5_main_host}`  
            }

          }
          this.getMiniConfig();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // 获取班级信息
    classInfo() {
      const data = {
        org_id: this.org_id,
        classId: this.class_id,
      };
      this.$axios.post('/stu/course/classInfo', data).then((res) => {
        if (res.data.code === 200) {
          this.chapter = res.data.data.chapter;
          this.studyNum = res.data.data.studyNum;
          this.numStatus = res.data.data.numStatus;
          this.comment = res.data.data.comment || '';
        }
      });
    },
    // 展示咨询图片
    handleShowWxImg() {
      this.isShowWxImg = !this.isShowWxImg;
      const body = document.querySelector('body');
      if (this.isShowWxImg) {
        body.setAttribute(
          'style',
          'position:fixed;left: 0px;right: 0px;overflow: hidden;'
        );
      } else {
        body.removeAttribute('style');
      }
    },

    handleStretchPart(id) {
      console.log(id, 'id>>>>');
      const el = this.$refs['part' + id];
      const icon = this.$refs['icon' + id];
      let elHeight = el[0].offsetHeight;
      if (elHeight === this.initHeight) {
        el[0].style.height = 'auto';
        elHeight = el[0].offsetHeight;
        el[0].style.height = this.initHeight + 'px';
        let f = document.body.offsetHeight;
        el[0].style.height = elHeight + 'px';
        icon[0].style.transform = 'rotate(0deg)';
      } else {
        el[0].style.height = this.initHeight + 'px';
        icon[0].style.transform = 'rotate(180deg)';
      }
    },
    // 改变登陆状态
    changeLoginState() {
      this.$refs.headerCpt.getUserInfo();
    },
    // 上报心跳
    startVodTime(file_id) {
      clearInterval(this.heartBeat);
      this.heartBeat = setInterval(() => {
        if (this.playStatus == 2) {
          let progress = 0;
          if (this.isThreeScreenCourse) {
            console.log(this.$refs.cameraVideo.getCurrentTime());
            progress = parseInt(this.$refs.cameraVideo.getCurrentTime() || 0);
          } else {
            console.log(this.$refs.mainVideo.getCurrentTime());
            progress = parseInt(this.$refs.mainVideo.getCurrentTime() || 0);
          }
          const data = {
            file_id,
            fans_id: this.fans_id,
            uid: this.org_id,
            progress,
          };
          this.$liveUser
            .post('/app/index/videoHeart', data)
            .then((res) => {
              if (res.data.code !== 200) {
                this.errorReport({ msg: '视频心跳接口报错', error: res.data });
              }
            })
            .catch((error) =>
              this.errorReport({ msg: '视频心跳报错', error: error })
            );
        }
      }, 5000);
    },
    async errorReport(data) {
      const postData = {
        fans_id: parseInt(this.fans_id),
        error_code: '80000',
        ds_id: 231410,
        uid: parseInt(this.org_id),
        terminal_type: 7,
        data,
      };
      try {
        await axios.post(
          'https://report.tenghuiwangxiao.cn/app/report/errorReport',
          postData
        );
      } catch (error) {
        console.log('上报错误');
      }
    },
    handlePlay() {
      if (this.$refs.cameraVideo && this.$refs.whiteBoard) {
        this.playStatus = 2;
        this.$refs.whiteBoard.play();
      }
    },
    handlePause() {
      if (this.$refs.cameraVideo && this.$refs.whiteBoard) {
        this.playStatus = 3;
        this.$refs.whiteBoard.pause();
      }
    },
    handleSeek(val) {
      if (this.$refs.cameraVideo && this.$refs.whiteBoard) {
        if (this.remainingTime === 0) {
          this.compareVideoTime();
        }
        this.$refs.whiteBoard.setCurrentTime(this.remainingTime + val);
      }
    },
    compareVideoTime() {
      const cameraTime = this.$refs.cameraVideo.getDuration;
      const courseTime = this.$refs.whiteBoard.getDuration;
      this.remainingTime = courseTime - cameraTime || 0;
    },
    // 获取当前课程有兑换码章节
    async getClassCode() {
      const data = {
        org_id: this.org_id,
        class_id: this.class_id,
        course_id: this.$route.params.setid,
      };
      const res = await this.$axios.post('/stu/course/getClassCode', data);
      if (res.data.code === 200) {
        const cdarr = res.data.data;
        this.codeArr = Object.values(cdarr);
      }
    },

    // 兑换码兑换课程
    useCdk() {
      const data = {
        org_id: this.org_id,
        code: this.codeData,
        class_id: this.class_id,
        course_id: this.$route.params.setid,
        chapter_id: this.chapter_id,
      };
      this.$axios.post('/stu/course/useCdk', data).then((res) => {
        console.log(res.data.code);
        if (res.data.code === 200) {
          this.$message({
            message: '兑换成功!',
            type: 'success',
          });
          this.code = false;
          this.codeData = '';
        } else if (res.data.code === 400) {
          this.errData = res.data.message;
        }
      });
    },
  },
};
</script>
<style scoped>
.video >>> .vod-player .main .progress #tf_progress_point {
  margin-top: -4px;
}
.video >>> .vod-player .main .progress #tf_progress_view {
  top: -2px;
}
.goumaigous {
  width: 300px;
  height: 60px;
  background: #ff571f;
  border-radius: 30px;
  font-size: 24px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 60px;
}
.yougoumai {
  width: 172px;
  height: 62px;
  background: #ff571f;
  border-radius: 0px 30px 30px 0px;
  line-height: 60px;
  text-align: center;
  font-size: 24px;
  font-family: MicrosoftYaHei;
  color: #ffffff;
}
.zuozixun {
  font-size: 24px;
  font-family: MicrosoftYaHei;
  text-align: left;
  color: #ff9c18;
  width: 172px;
  height: 60px;
  background: #ffffff;
  border: 1px solid #ff9c18;
  border-radius: 30px 0px 0px 30px;
  line-height: 60px;
  text-align: center;
}
.baomingrs {
  font-size: 14px;
  font-family: MicrosoftYaHei;
  color: #8b8b8b;
  margin-left: 9px;
}
.yuanjia {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-decoration: line-through;
  color: #939393;
  margin-left: 15.5px;
}
.shijijia {
  font-size: 40px;
  font-family: PingFang SC, PingFang SC-Semibold;
  font-weight: 600;
  color: #ff3700;
  margin-top: 27px;
  margin-left: 30px;
}
.yuyuyu >>> .el-dialog {
  margin-top: 0 !important;
  border-radius: 20px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.kechengduihuan {
  font-size: 20px;
  font-family: PingFangSC-Medium;
  text-align: center;
  color: #202020;
}
.huoqulist {
  font-size: 12px;
  font-family: PingFang SC, PingFang SC-Regular;
  font-weight: 400;
  text-align: center;
  color: #999999;
  margin-top: 1px;
}
.duihuan-content {
  width: 244px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
}
.yuyuyu >>> .el-input {
  box-sizing: border-box;
  width: 220px;
  height: 44px;
  border-radius: 4px 0px 0px 4px;
  border: 1px solid #1872ed;
}
.yuyuyu::v-deep .el-input .el-input__inner {
  width: 100%;
  height: 100%;
  border: none;
}
.lijiduan {
  width: 50px;
  height: 44px;
  text-align: center;
  line-height: 44px;
  border-radius: 0px 4px 4px 0px;
  background: #1872ed;
  border: none;
  color: #fff;
}
.keduihuan {
  width: 40px;
  height: 16px;
  background: #f33f27;
  border-radius: 2px;
  font-size: 10px;
  font-family: PingFangSC-Regular;
  text-align: left;
  color: #ffffff;
  line-height: 14px;
  margin-left: 5px;
  padding-left: 2px;
  line-height: 16px;
}
.yiguoqilist {
  font-size: 10px;
  font-family: PingFangSC-Regular;
  text-align: left;
  color: #ff5227;
  line-height: 20px;
  padding-left: 15px;
}
.yuyuyu >>> .el-dialog--center .el-dialog__body {
  padding: 25px 25px 0px;
}
</style>
<style lang="scss" scoped>
/* 公共样式 */
* {
  padding: 0;
  margin: 0;
}

a {
  color: #434343;
  text-decoration: none;
  /* 取消下划线 */
}

li {
  list-style: none;
}
p {
  margin: 0;
  padding: 0;
}

body {
  background-color: #fff;
  /* 整个页面的颜色 */
  font-size: 14px;
}

input {
  border: 0;
  /* 所有的input边框为0 */
  outline: none;
  /* 去掉默认边框 */
  box-sizing: border-box;
  /* css3模型 border和padding 包含在盒子里 */
}

.container {
  margin: 0 auto;
  // padding-left: calc(100vw - 100%);
}

/* 课程详情部分开始 */
.details {
  background-color: #f5f6f7;
  padding-bottom: 30px;
  min-width: 972px;
}

.details-header {
  height: 60px;
  line-height: 60px;
  font-size: 14px;
  color: #4d4d4d;
}

.details-header a {
  color: #545454;
}

.details-header span {
  color: #545454;
  padding: 0 14px;
}
.course-img {
  background-position: center;
  background-size: cover;
  min-width: 645px;
  min-height: 430px;
  .main-video {
    width: 100%;
    height: 100%;
  }
  .whiteBoard {
    width: 100%;
    height: 100%;
  }
}

.video-population {
  height: 600px;
}

.video-playback {
  width: 900px;
  height: 600px;
  float: left;
  background-color: pink;
}

.video-details {
  width: 360px;
  height: 600px;
  float: left;
  background-color: #191a20;
  overflow-y: scroll;
}

.video-details ul li {
  height: 70px;
}

.video-details a {
  display: block;
  height: 70px;
  margin-bottom: 6px;
}

.video-details a .span02 {
  display: block;
  width: 21px;
  height: 28px;
  float: left;
  margin: 20px 17px 0 24px;
  text-align: center;
  color: #515151;
  font-size: 18px;
  font-weight: 500;
}

.video-details a div {
  float: left;
  margin-top: 20px;
}

.video-details a div p {
  font-size: 16px;
  color: #b7b7b7;
}

.video-details a div p span {
  display: block;
  float: left;
  width: 30px;
  height: 16px;
  background-color: #ff9d2d;
  color: #fff2e4;
  font-size: 12px;
  text-align: center;
  border-radius: 2px;
  margin-top: 2px;
  margin-right: 9px;
}

.video-details a div p:last-child {
  color: #515151;
  font-size: 12px;
  margin-top: 5px;
}

/* ????? */
.video-details a:hover p {
  color: #10a675;
}

.video-details a:hover .span02 {
  color: #10a675;
}

.video-details a:hover p:last-child {
  color: #10a675;
}

.video-details a:focus p {
  color: #10a675;
}

.video-details a:focus .span02 {
  color: #10a675;
}

.video-details a:focus p:last-child {
  color: #10a675;
}

.video-consultation {
  height: 110px;
  background: #ffffff;
  margin-top: 20px;
}

.video-consultation-left {
  float: left;
  margin-left: 30px;
  // width: 900px;
  height: 90px;
}

.video-consultation-left p:first-child {
  padding-top: 20px;
  font-size: 24px;
  font-weight: 700;
  color: #b7b7b7;
  margin-bottom: 10px;
}

.video-consultation-left p:nth-child(2) {
  display: block;
  float: left;
  padding-right: 40px;
  color: #7e7e7f;
}

.video-consultation-left p img {
  padding-right: 10px;
}

.video-consultation-left p:last-child {
  display: block;
  float: left;
  color: #7e7e7f;
}

.video-consualtation-right {
  width: 300px;
  padding-right: 30px;
  padding-top: 17px;
  float: right;
  cursor: pointer;
}

.video-consultation-mid {
  padding-top: 17px;
  float: right;
  color: #b7b7b7;
  width: 300px;
  font-size: 22px;
  margin-right: 46px;
}

.video-consultation-mid-box {
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.video-consualtation-right a {
  display: block;
  // width: 300px;
  height: 57px;
  background-color: #10a675;
  color: #ffffff;
  font-size: 22px;
  border-radius: 25px;
  line-height: 57px;
  text-align: center;
}

/* 信息部分 */
.information {
  margin-top: 20px;
}

.information-container {
  width: 810px;
  margin: 0 auto;
  margin-bottom: 20px;
}
/* 切换班级样式 */
.change-class {
  display: flex;
  padding: 10px 0;
  align-items: center;
}
.class-title {
  margin-right: 10px;
}
.el-select-dropdown__item {
  margin-left: 15px;
}
.information-left {
  margin-top: 40px;
  // width: 870px;
  width: 972px;
  float: left;
  background-color: #ffffff;
  padding-bottom: 20px;
}

.information-left-header {
  border-bottom: 2px solid #e8eaec;
  line-height: 20px;
  font-size: 16px;
  display: flex;
}
.information-left-header .change-class {
  margin-left: auto;
}

.information-left-header-left {
  padding: 22px 0;
  font-size: 16px;
  color: #20242f;
  border-bottom: 1px solid #e8eaec;
  font-weight: 700;
  border: none;
}
.info-content {
  font-size: 14px;
}

.information-left-header-left a:nth-child(2) {
  margin: 0 60px;
}

.information-left-header-left a:nth-child(2) span {
  padding-bottom: 18px;
  border-bottom: 4px solid #10a675;
}

.information-left-header-right {
  float: right;
}

.information-left-header-right img {
  padding-right: 8px;
}
.course-content-main {
  display: flex;
}
@media screen and (max-width: 992px) {
  .course-chapter {
    max-height: 430px;
    position: relative;
  }
}
.course-chapter {
  background: #191a20;
  flex: 1;
  overflow-y: auto;
  color: #b7b7b7;
  padding: 0 20px;
  position: relative;
  box-sizing: border-box;
  .chapter-main {
    overflow: hidden;
    transition: all 0.5s;
    height: 56px;
  }
  .camera-video {
    width: 100%;
    height: 100%;
  }
}
/* 滚动条样式 */
.course-chapter::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
.course-chapter::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: #535353;
}
.course-chapter::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  background: #ededed;
}
.contentWx-cover {
  position: fixed;
  left: 0;
  right: 0;
  top: 64px;
  bottom: 0;
  background: #0c0d1094;
  z-index: 1000;
}
.aglook {
  width: 48px;
  padding: 2px 5px;
  color: white;
  background: #409eff;
  margin-left: 10px;
  border-radius: 5px;
  font-size: 12px;
  position: absolute;
}
.contentWx-img {
  width: 400px;
  height: 500px;
  background: #ffffff;
  border-radius: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 40px 0;
  z-index: 998;
}
.contentWx-img {
  width: 400px;
  height: 500px;
  background: #ffffff;
  border-radius: 16px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  box-sizing: border-box;
  padding: 40px 0;
}
.contentWx-img div:first-child {
  font-size: 24px;
}
.contentWx-img div:last-child {
  font-size: 20px;
}
.contentWx-cover img {
  width: 40%;
  margin: 30px 0;
}
.contentWx-img button {
  width: 30px;
  height: 30px;
  position: absolute;
  top: 20px;
  right: 20px;
  // width: 35%;
  // height: 42px;
  border-radius: 29px;
  //
  color: #ffffff;
  border: none;
  cursor: pointer;
}

/* 目录信息 */
.information-left-catalogue {
  height: 1100px;
}

.information-left-catalogue .mulu {
  min-height: 90px;
  width: 810px;
  margin-top: 20px;
  background-color: #f9f9f9;
}

.information-left-catalogue div {
  display: block;
}

.information-left-catalogue div {
  float: left;
  margin-top: 20px;
}

.information-left-catalogue p {
  font-size: 16px;
  color: #20242f;
}

.information-left-catalogue .leixin {
  display: block;
  float: left;
  width: 30px;
  height: 16px;
  background-color: #10a675;
  color: #fff2e4;
  font-size: 12px;
  text-align: center;
  border-radius: 2px;
  margin-top: 2px;
  margin-right: 9px;
}

.span01 {
  display: block;
  width: 27px;
  height: 28px;
  float: left;
  margin: 16px 20px 0 20px;
  text-align: center;
  color: #10a675;
  font-size: 24px;
}

.information-left-catalogue p:last-child {
  color: #808695;
  font-size: 14px;
  margin-top: 20px;
}

.information-left-catalogue a {
  height: 30px;
  width: 90px;
  line-height: 30px;
  text-align: center;
  display: block;
  float: right;
  border: 1px solid #10a675;
  border-radius: 25px;
  margin-top: 29px;
  margin-right: 20px;
}

/* 右边 */
.information-right {
  width: 360px;
  float: right;
  background-color: #ffffff;
}

.information-right01 {
  height: 84px;
  margin-top: 22px;
}

.information-right01 span {
  display: block;
  float: left;
  height: 64px;
  width: 55px;
  line-height: 64px;
  color: #ffffff;
  background-color: #10a675;
  padding-left: 9px;
  font-size: 15px;
  letter-spacing: 1px;
  font-weight: 700;
  border-radius: 10px;
}

.information-right01 div {
  float: left;
  padding-left: 12px;
}

.information-right01 div p:first-child {
  font-size: 20px;
  padding-top: 3px;
}

.information-right01 div p:last-child {
  color: #9a9fab;
  padding-top: 10px;
}

.information-right02 {
  height: 72px;
}

.information-right02 div {
  width: 93.3px;
  height: 72px;
  text-align: center;
  background-color: #f9f9f9;
  float: left;
}

.information-right02 div:nth-child(2) {
  margin: 0 10px;
}

.information-right02 div p {
  color: #9fa4af;
  padding: 15px 0;
}

.information-right03 {
  margin-top: 25px;
  margin-bottom: 20px;
}

.information-right03 p {
  text-indent: 2em;
  /* 首行缩进 */
  line-height: 150%;
}

.information-right03 p span {
  letter-spacing: 1px;
}

/* 课程详情部分结束 */
/* 合作与联系开始 */
.contact {
  height: 210px;
  background-color: #101115;
}

.contact-left {
  float: left;
}

.contact-left dt {
  color: #82858a;
  font-size: 20px;
  font-weight: 700;
  padding-top: 55px;
  padding-bottom: 12px;
  letter-spacing: 4px;
  /* 字间距为4px */
}

.contact-left dd {
  color: #65676c;
  font-size: 13px;
  padding-top: 20px;
}

.contact-right {
  float: right;
}

.contact-right img {
  padding-top: 46px;
  padding-bottom: 12px;
}

.contact-right p {
  color: #65676c;
}

.contact-middle {
  float: right;
  margin-right: 93px;
}

.contact-middle dd {
  color: #65676c;
  font-size: 13px;
  padding-top: 20px;
}

.contact-middle dd:first-child {
  padding-top: 52px;
}

.contact-middle dd:nth-child(2) {
  padding-top: 20px;
}

.contact-middle dd:last-child {
  padding-top: 14px;
}

.contact-middle dt {
  color: #82858a;
  font-size: 20px;
  padding-top: 23px;
}

/* 合作与联系结束 */
/* 尾部开始 */
.tail {
  height: 50px;
  line-height: 50px;
  background-color: #0c0d10;
}

.tail p {
  width: 100%;
  color: #65676c;
  font-size: 13px;
  margin: auto;
  text-align: center;
}
.chapter-title {
  height: 44px;
  width: 100%;
  margin-top: 12px;
  font-size: 16px;
  color: #e6e6e6;
  line-height: 44px;
  background: #2b2c35;
  box-sizing: border-box;
  position: relative;
  cursor: pointer;
  .chapter-text {
    // display: block;
    width: 95%;
    max-width: 310px;
    padding-left: 12px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .iconfont {
    position: absolute;
    right: 10px;
    transition: all 0.5s;
  }
}

.course-chapter-item {
  margin-top: 20px;
  padding: 0 16px 0 24px;
  display: flex;
  cursor: pointer;
}
.chapter-item-num {
  margin-right: 12px;
  font-size: 18px;
  color: #515151;
}
.chapter-item-content {
  position: relative;
  flex: 1;
}
.item-content-top {
  display: flex;
  align-items: start;
  position: relative;
  margin-bottom: 16px;
}

.sort {
  position: relative;
  // right: -60px;
  width: 100%;
  display: flex;
  margin: 8px 0px;
  font-size: 12px;
  justify-content: right;
}
.stbx {
  position: absolute;
  top: -33px;
  right: -55px;
  width: 48px;
  height: 20px;
  display: flex;
  z-index: 88;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: solid #b7b7b7 1px;
}
.stbx1 {
  color: #10a675;

  border: solid #10a675 1px;
}
.sortimg {
  width: 8px;
  height: 8px;
}
.chapter-review {
  min-width: 30px;
  height: 16px;
  font-size: 12px;
  color: #ffffff;
  background: #ff9d2d;
  border-radius: 2px;
  text-align: center;
  margin-right: 8px;
}
.chapter-no-review {
  width: 30px;
  height: 16px;
  margin-right: 8px;
}

.chapter-item-title {
  font-size: 16px;
  color: #b7b7b7;
  font-weight: 700;
  line-height: 1;
  max-width: 115px;
  overflow: hidden; // （文字长度超出限定宽度，则隐藏超出的内容）
  white-space: nowrap; // （设置文字在一行显示，不能换行）
  text-overflow: ellipsis; // （规定当文本溢出时，显示省略符号来代表被修剪的文本）
}
.chapter-item-title:hover {
  white-space: pre-wrap;
  height: auto;
  overflow: visible;
}
.item-content-bottom {
  font-size: 12px;
  color: #515151;
  margin-bottom: 16px;
}
.chapter-review-item {
  font-size: 14px;
  color: #b7b7b7;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  position: relative;
  .iconfont {
    margin-right: 6px;
    transform: translateY(1px);
  }
}
.review-active {
  color: #10a675;
}
.chapter-review-item img {
  width: 14px;
  height: 14px;
  margin-right: 8px;
}
// .review-item-time {
//   position: absolute;
//   right: 0px;
// }
.live {
  display: flex;
}
.enter-live {
  font-size: 12px;
  width: 60px;
  height: 24px;
  background: #10a675;
  color: #fefffe;
  line-height: 24px;
  text-align: center;
  border-radius: 16px;
  transform: translateY(3px);
  margin-left: 6px;
}
.live-status {
  color: #10a675;
  transform: translateY(4px);
}
.live-over {
  color: #b7b7b7;
  font-size: 12px;
  text-align: center;
  // transform: translateY(5px);
  .download_fj {
    margin-top: 4px;
    display: block;
    padding: 2px;
    background-color: #10a675;
    border-radius: 25px;
    width: 52px;
    color: #fff;
    margin-left: 5px;
  }
}
.titleshow {
  display: none;
  width: 100%;
  position: absolute;
  top: 32px;
  z-index: 99;
  left: 0;
  background: #333333;
}
.item-content-top:hover .titleshow {
  display: block;
}

/* 尾部结束 */
</style>
